const baseURL = 'https://dxntingomaria.com/';

export default baseURL;
